export default __webpack_public_path__ + "static/media/greenL.87621089.jpeg";